import LoadingContent from "../../feedback/loading-content";

export default LoadingContent;
